import React from "react";

import { ContentSubtype } from "../types/ContentSubtype";
import { isMovieContentSubtype } from "../types/MovieContentSubtype";

interface MovieComponentRendererProps {
    subtype?: ContentSubtype;
    children: React.ReactNode;
}

export const MovieComponentRenderer: React.FC<MovieComponentRendererProps> = ({
    subtype,
    children
}: MovieComponentRendererProps) => {
    if (subtype && isMovieContentSubtype(subtype)) {
        return <>{children}</>;
    }

    return <></>;
};
